import { render, staticRenderFns } from "./ChildrenInstallations.vue?vue&type=template&id=96b12f00&"
import script from "./ChildrenInstallations.vue?vue&type=script&lang=js&"
export * from "./ChildrenInstallations.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenInstallations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports